import React, { useState, useEffect } from "react";
import Loading from "../effect-components/Loading";
import Tours from "./Tours";
import "./tourlist.css";

const url = "https://course-api.com/react-tours-project";

function TourList() {
  const [loading, setLoading] = useState(true);
  const [tours, setTours] = useState([]);

  const removeTour = (id) => {
    const newTours = tours.filter((tour) => tour.id !== id);
    setTours(newTours);
  };
  const fetchTours = async () => {
    setLoading(true);
    try {
      const response = await fetch(url);
      const tours = await response.json();
      setLoading(false);
      setTours(tours);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchTours();
  }, []);

  if (loading) {
    return <Loading />;
  }

  if (tours.length === 0) {
    return (
      <main className="title">
        <h2>No tours left</h2>
        <button className="btn btn-primary" onClick={fetchTours}>
          Fetch again
        </button>
      </main>
    );
  }

  return (
    <main className="tourlist">
      <Tours tours={tours} removeTour={removeTour} />
    </main>
  );
}

export default TourList;
